module.exports = __webpack_public_path__ + "static/media/bg_painter_didi.3ca123a9.jpg";